import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";


import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import InputGroup from "./../../elements/InputGroup";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";

const CustomTemplateModal = ({
  setCreateCustomTemplateModal,
  defaultLibraryList,
  createCustTemplate
  // applyFiltersHandler,
}) => {
  const [assigneeId, setAssigneeId] = useState(null);
  const [approverId, setApproverId] = useState(null);
  const [parentLibraries, setParentLibraries] = useState([]);
  const [selParentLibId, setSelParentLibId] = useState(null);
  const [custTemplateName, setCustTemplateName] = useState("");
  const [custTemplateDesc, setCustTemplateDesc] = useState("");

  const [templateName, setTemplateName] = useState("");
  const [createdBy, setCreatedBy] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [status, setStatus] = useState(null);
  const animatedComponents = makeAnimated();

  useEffect(()=>{
    defaultLibraryList.forEach((obj)=>{
      setParentLibraries((prev)=>[...prev,{label:obj.name,value:obj._id}])
    })
  },[])

  const localStyles = {
    ...customStyles,
    control: (provided, state) => ({
      ...(customStyles.control ? customStyles.control(provided, state) : provided),
      display: "flex",
      alignItems: "center",
      minHeight: "38px",
      height: "38px",
      borderColor: "#c2e6d1",
      borderWidth: "1px",
      borderStyle: "solid",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#b3c0bd"
      }
    }),
    valueContainer: (provided, state) => ({
      ...(customStyles.valueContainer ? customStyles.valueContainer(provided, state) : provided),
      height: "100%",
      display: "flex",
      alignItems: "center",
      padding: "0 8px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused || state.isSelected ? "#f4faf5" : "#ffffff",
      color: "#4d6d64",
      cursor: "pointer",
      borderRadius: "6px",
      marginBottom: "4px",
      fontSize: "13px",
      ":active": {
        backgroundColor: "#f4faf5",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    singleValue: (provided) => ({
      ...(customStyles.singleValue ? customStyles.singleValue(provided) : provided),
      color: "#205a46",
      fontSize: "13px",
      margin: "0px",
      padding: "0px",
    }),
    input: (provided) => ({
      ...(customStyles.input ? customStyles.input(provided) : provided),
      color: "#205a46",
      margin: "0px",
      padding: "0px",
    }),
    placeholder: (provided) => ({
      ...(customStyles.placeholder ? customStyles.placeholder(provided) : provided),
      fontSize: "13px",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      margin: 0
    }),
    dropdownIndicator: (provided) => ({
      ...(customStyles.dropdownIndicator ? customStyles.dropdownIndicator(provided) : provided),
      paddingTop: "10px",
    }),
    indicatorSeparator: () => null,
  };
  const handleCreateCustTemplate = () => {
    const payload = {
        parentTemplateID: selParentLibId ,
        name: custTemplateName ,
        description: custTemplateDesc 
    };
    createCustTemplate(payload);
  };

  return (
    <Modal
      width={"35%"}
      minHeight={"350px"}
      title="Create Custom Template"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          <CloseIcon
            style= {{ cursor: "pointer" }}
            onClick={() => {
              setCreateCustomTemplateModal(false);
            }}
          />
        </>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setCreateCustomTemplateModal(false);
            }}
            label="Cancel"
          />
          <span>
            &ensp;
            <Button
              btnColor={buttoncss.primary}
              label="Create Template"
              onClick={() => {
                handleCreateCustTemplate();
              }}
            />
          </span>
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <div className="mb-3">
          <label style={{ fontSize: "14px", color: "#205a46", display: "block", marginBottom: "4px" }}>
            Select Parent Template
          </label>
          <Select
            options={parentLibraries}
            onChange={(e) => { setSelParentLibId(e.value); }}
            placeholder={"Select Template"}
            styles={localStyles}
            components={{ DropdownIndicator: CustomDropdownIndicator, animatedComponents }}
            isSearchable={true}
          />
        </div>

        <InputGroup
          class_="mb-3 mt-3"
          label="Template Name"
          inputs={[
            <>
              <input
                name="tag"
                value={custTemplateName || ""}
                onChange={(e) => {
                  setCustTemplateName(e.target.value);
                }}
                placeholder="Template Name"
                style={{
                  border: "1px solid #c2e6d1",
                  borderRadius: "6px",
                  padding: "8px",
                  width: "100%",
                  outline: "none"
                }}
              />
            </>,
          ]}
        />

        <InputGroup
          class_="mb-3 mt-2"
          label="Template Description"
          inputs={[
            <>
              <textarea
                name="Template Description"
                placeholder="Template Description"
                value={custTemplateDesc || ""}
                onChange={(e) => {
                  setCustTemplateDesc(e.target.value);
                }}
                style={{
                  border: "1px solid #c2e6d1",
                  borderRadius: "6px",
                  padding: "8px",
                  width: "100%",
                  outline: "none",
                  minHeight: "60px"
                }}
              />
            </>,
          ]}
        />
      </div>
    </Modal>
  );
};

export default CustomTemplateModal;
